import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core'
import { MediaFile, MediaRoot } from 'elements-sdk'
import { BaseComponent } from 'common/helpers'
import { MediaBrowserSelection } from 'media/services/mediaBrowserSelection.service'

@Component({
  selector: 'media-directory-item',
  templateUrl: './mediaDirectoryItem.component.pug',
  styleUrls: ['./mediaDirectoryItem.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MediaDirectoryItemComponent extends BaseComponent {
  @Input() directory: MediaFile
  @Input() location?: MediaFile
  @Input() root?: MediaRoot
  @Input() selectable = true
  @Output() onSelect = new EventEmitter<MouseEvent>()

  constructor (
    private cdr: ChangeDetectorRef,
    public mediaBrowserSelection: MediaBrowserSelection,
  ) {
    super()
    this.subs.add(this.mediaBrowserSelection.change$.subscribe(() => cdr.markForCheck()))
  }

  get name (): string {
    if (this.root?.nameField) {
      // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
      return this.directory.customFields![this.root.nameField] || this.directory.name
    }
    return this.directory.name
  }

  onCheckbox (event: MouseEvent) {
    this.onSelect.emit(event)
    event.stopPropagation()
  }
}
